<template>
  <div>
    <span v-if="labelName" :class="labelClass">{{ labelName }}</span>
    <span v-if="isStarRating" :class="ratingClass">
      <refapp-star-rating
        :aria-label="starRatingAccessibleLabel"
        class="vue-star-rating"
        star-classes="vue-star-rating-star"
        :increment="starRatingIncrementValue"
        :max-rating="starRatingMaxRatingValue"
        :inactive-color="starRatingInactiveColor"
        :active-color="starRatingActiveColor"
        :star-size="customStarSize"
        :rating="productRating"
        readonly
      />
    </span>
    <span v-else class="rfp-rr-show-full-review-164-or rr-label-info float-left">{{
      labelValue
    }}</span>
  </div>
</template>

<script>
import RefappStarRating from '../../../../../shared/components/star-rating/refapp-star-rating.vue';

export default {
  name: 'rfp-ratings-product-star',
  components: {
    RefappStarRating,
  },
  inject: [
    'starRatingActiveColor',
    'starRatingInactiveColor',
    'starRatingIncrementValue',
    'starRatingMaxRatingValue',
    'starRatingStarSize',
    'starRatingAccessibleLabel',
  ],
  props: {
    productRating: {
      type: Number,
      default: 1,
    },
    labelName: {
      type: String,
      default: '',
    },
    labelValue: {
      type: String,
      default: '',
    },
    isStarRating: {
      type: Boolean,
      required: true,
    },
    propStarSize: {
      type: Number,
      required: false,
    },
    labelClass: {
      type: String,
      default: 'rfp-rr-show-full-review-161-or rr-label bold',
    },
    ratingClass: {
      type: String,
      default: 'rfp-rr-show-full-review-162-or rfp-star-rating',
    },
    isPopup: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      customStarSize: this.propStarSize || this.starRatingStarSize,
    };
  },
};
</script>
